import React from "react";
import body from "../../../assets/images/underdev.png";

const AboutImage = () => (
    <div>
        <img src={body}  className="App-logo" alt="logo" />
    </div>
);

export default AboutImage;